import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getGiaoHangState = state => state.giaoHang;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function handleFileRequest(request) {
  return request
    .then(function (response) {
      return response.data;
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_LIST_API,
    formData
  )

  return handleRequest(request);
}

function listHistoryRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_HISTORY_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function giaoHangUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function giaohangListNvRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_LIST_NV_API,
    formData
  )

  return handleRequest(request);
}

function exportXlsRequestApi(formData) {
  let url = `${Constants.GIAOHANG_EXPORT_API}?store_id=${formData.store_id}`
  url += `&keyword=${formData.keyword}&den_ngay=${formData.den_ngay}&tu_ngay=${formData.tu_ngay}&status=${formData.status}&nvGiaoHang=${formData.nvGiaoHang}`;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function* giaohangListNvFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(giaohangListNvRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(brActions.giaohangListNvSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data.records || []);
    }
  } catch (error) {
    yield put(brActions.giaohangListNvError(error))
  }
}

function* giaoHangListRequestFlow() {
  const giaoHang = yield select(getGiaoHangState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, giaoHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.giaoHangListSuccess(results.data))

  } catch (error) {
    yield put(brActions.giaoHangListError(error))
  }
}

function* giaoHangHistoryListRequestFlow() {
  const giaoHang = yield select(getGiaoHangState);
  try {
    // grab the client from our action
    const results = yield call(listHistoryRequestApi, giaoHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.giaoHangHistoryListSuccess(results.data))

  } catch (error) {
    yield put(brActions.giaoHangHistoryListError(error))
  }
}

function* giaoHangDetailRequestFlow() {
  const giaoHang = yield select(getGiaoHangState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, giaoHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.giaoHangDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.giaoHangDetailError(error))
  }
}

function* giaoHangUpdateRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const result = yield call(giaoHangUpdateRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.giaoHangUpdateSuccess(result))
    yield call(callback)
  } catch (error) {
    yield put(brActions.giaoHangUpdateError(error))
  }
}

function* giaohangExportXlsRequestFlow({ payload, onSuccess }) {
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, payload)
    if (!results || (results.code && results.code != 200)) {
      return yield put(brActions.giaohangExportXlsError("Lỗi trong quá trình lấy dữ liệu"))
    }
    if (results.code && results.code != 200) {
      return yield put(brActions.giaohangExportXlsError(results.message))
    }
    // dispatch the action with our widgets!
    yield put(brActions.giaohangExportXlsSuccess())
    // callback on success
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, results)
    }
  } catch (error) {
    yield put(brActions.giaohangExportXlsError(error))
  }
}

function* giaoHangWatcher() {
  yield [
    takeLatest(Constants.GIAOHANG_LIST_REQUESTING, giaoHangListRequestFlow),
    takeLatest(Constants.GIAOHANG_DETAIL_REQUESTING, giaoHangDetailRequestFlow),
    takeLatest(Constants.GIAOHANG_UPDATE_REQUESTING, giaoHangUpdateRequestFlow),
    takeLatest(Constants.GIAOHANG_LIST_NV_REQUESTING, giaohangListNvFlow),
    takeLatest(Constants.GIAOHANG_EXPORT_XLS_REQUESTING, giaohangExportXlsRequestFlow),
    takeLatest(Constants.GIAOHANG_HISTORY_LIST_REQUESTING, giaoHangHistoryListRequestFlow),
  ]
}

export default giaoHangWatcher



// WEBPACK FOOTER //
// ./src/views/GiaoHang/sagas.js